import React, { Fragment, useContext, useState, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Button from '../../lib/ui/buttons/Button';
import InputField from '../../lib/ui/inputs/Input';
import DropDown from "../../lib/ui/dropdown/Dropdown";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import LogoBranding from '../../lib/ui/logoBranding/LogoBranding';
import { LangCtx } from "../../lib/context";
import { langObj } from "../../locale/index";
import 'react-phone-number-input/style.css';
import '../../lib/ui/imageicon/Styles.css';
import '../../lib/ui/inputs/InputStyles.css';
import "../../layouts/Layouts.css";
import "../../ui-styles/picker/picker.css";
import PlansList from "../../config/plans.json";
import { validateEmail } from "../../lib/validation"
import AddrDropDown from '../../lib/ui/dropdown/addressDropDown';
import { subscribePlan } from "../../actions/payment";
import StripeCheckout from 'react-stripe-checkout';
import Loading from "../../components/loading";
// import ConfirmMsgPopup from "./ConfirmMsgPopup";
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import { getSubdomain } from '../../lib/domain';
// const psl = require("psl");

const AdminSignupPage = (props) => {
    const { l, setLang } = useContext(LangCtx);
    const history = useHistory();

    const [errorMsg, setErrorMsg] = useState('');
    const [firstName, setfirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [plan, setPlan] = useState('');
    const [password, setPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [submitted_data, setSubmitted] = useState(null);
    const [loading, setLoading] = useState(false);
    const check_ref = useRef(null);
    const [title, setTitle] = useState('Mr');
    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);


    const handleLang = (e) => {
        setLang(langObj[e.target.value]);
        localStorage.setItem('lang', e.target.value);
    }

    const handleSignupBtn = (e) => {
        e.preventDefault();
        try {

            if (firstName === '' || lastName === '') {
                setErrorMsg(l.pls_ent_fName_lName)
            }
            else if (companyName === '') {
                setErrorMsg(l.pls_ent_comp_name)
            }
            else if (email === '' || email == null || !validateEmail(email)) {
                setErrorMsg(l.pls_valid_mail)
            }
            else if (phone === '' || phone == null || !isValidPhoneNumber(phone)) {
                setErrorMsg(l.pls_check_phone)
            }
            else if (password === '') {
                setErrorMsg(l.enter_pass)
            }
            else if (password !== confPassword) {
                setErrorMsg(l.psw_confpsw_should_same)
            }
            else if (plan === '') {
                setErrorMsg(l.pls_sel_plan)
            }
            else {
                setErrorMsg('');
                setLoading(true);
                const phoneNumber = parsePhoneNumber(phone)
                const countrycode = phoneNumber.countryCallingCode;
                const number = phoneNumber.nationalNumber;
                let body = {
                    userData: {
                        firstName: firstName.trim(),
                        lastName: lastName.trim(),
                        email: email.trim(),
                        countryCode: countrycode,
                        phone: number.trim(),
                        password: password,
                        plan: plan,
                        companyName: companyName,
                        doctorsCount: 50,
                        clinicsCount: 3
                    },
                    plan: "basic"
                }
                setSubmitted(body);
                setTimeout(() => {
                    check_ref.current.onClick();
                }, 300);
            }
            setLoading(false);


        } catch (err) {
            console.log("Error", err);
            let msg = err && err.message ? err.message : l.unable_upd_patient;
            setErrorMsg(msg);
            setLoading(false);
        }

    }

    const onClose = () => {
        setLoading(false);
    }

    const onToken = (token) => {
        //  e.preventDefault();
        try {
            let body = { ...submitted_data };
            body['token'] = token;
            subscribePlan(body).then(response => {
                history.push('/confirm-msg');
                alert(`We are in business, ${response.email}`);
            });
        } catch (err) {
            console.log("Error", err);
            let msg = err && err.message ? err.message : l.unable_upd_patient;
            setErrorMsg(msg);
        }

    }


    const langOptions = [{ value: "en", label: l.english }, { value: "hi", label: l.hindi }, { value: "fr", label: l.french }]
    const titlesList = [{ value: "Mr.", label: "Mr." }, { value: "Mrs.", label: "Mrs." }, { value: "Ms.", label: "Ms." }, { value: "Master", label: "Master" }, { value: "Miss", label: "Miss" }]

    return <Fragment>
        <div className="coverContainer">
            <div className="outSideContainer">
                <div className="colCredential">
                    {loading && <Loading />}
                    <div className="topRow">
                        <div className="langBlock">
                             {_domain?.subdomain === process.env.REACT_APP_defaultdomian && <div className="helpBtn DeskDisplayorNot">
                               <a className='logintollfree flexInline alignCntr' href="https://help.instavc.com/inclinic" target="_blank" rel="noopener noreferrer">
                                    <PlayCircleFilledWhiteIcon className='callIcon' fontSize='small' />{l.help_center}
                                </a>
                            </div>}
                            {/*<div className="helpBtn mobDisplayorNot">
                                <a className='logintollfree flexInline alignCntr' href="https://help.instavc.com/inclinic" target="_blank">
                                    <PlayCircleFilledWhiteIcon className='callIcon' fontSize='small' />{l.help}
                                </a>
                            </div> */}
                            <DropDown placeholder="Languages" items={langOptions} value={localStorage.getItem('lang') ? localStorage.getItem('lang') : l.locale} onChange={handleLang} />
                        </div>
                    </div>

                    <div className="bodyRow">
                        <div className="brandingBlock">
                            <LogoBranding />
                        </div>
                        <div className="crdFormBlock">
                            <div className="crdHeadingBlock justifyCenter">
                                <h2 className="headingTxt">{l.admin_signup}</h2>
                            </div>

                            {errorMsg && errorMsg !== "" && <div className="errorBox">
                                <small className="errorTxt">{errorMsg}</small>
                            </div>
                            }

                            <div className="colBlock">
                                <div className="rowBlock">
                                    <div className="inputRowGroup flex0 mrgRight8">
                                        <small className="inpLabel">{l.label_title}<span className="redTxt">*</span>:</small>
                                        <AddrDropDown
                                            placeholder={l.select_title}
                                            items={titlesList}
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>
                                    <div className="inputRowGroup mrgRight8">
                                        <small className="inpLabel">{l.inp_fname}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            name="firstName"
                                            placeholder={l.inp_fname}
                                            type="text"
                                            value={firstName}
                                            maxLength="30"
                                            onChange={(e) => setfirstName(e.target.value)}
                                        />
                                    </div>
                                    <div className="inputRowGroup">
                                        <small className="inpLabel">{l.inp_lname}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            placeholder={l.inp_lname}
                                            name="lastName"
                                            type="text"
                                            maxLength="30"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <InputField
                                    placeholder={l.company_name}
                                    name="companyName"
                                    type="text"
                                    maxLength="50"
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                />
                                <InputField
                                    placeholder={l.email_address}
                                    type="email"
                                    value={email}
                                    maxLength="50"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <div className="inputBox colBlock nopdng">
                                    <PhoneInput className="customPkgInput"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        maxLength="17"
                                        value={phone}
                                        onChange={setPhone} />
                                    <label>{props.label}</label>
                                    {props.error && <span className="inputErrorMsg">{props.errorMsg}</span>}
                                </div>
                                <InputField
                                    placeholder={l.pass}
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    maxLength="30"
                                    showPwd={true}

                                />
                                <InputField
                                    placeholder={l.confirm_pwd}
                                    type="password"
                                    value={confPassword}
                                    maxLength="30"
                                    onChange={(e) => setConfPassword(e.target.value)}
                                    showPwd={true}

                                />
                                <AddrDropDown
                                    placeholder={l.plan_package}
                                    items={PlansList}
                                    value={plan}
                                    onChange={(e) => setPlan(e.target.value)}
                                />
                                {/* <form id="forgotform" onSubmit={handleSignupBtn}>
                                    <div className="crdBtnContainer">  */}
                                {submitted_data ?
                                    <StripeCheckout currency="INR" ref={check_ref} closed={onClose}
                                        name="Basic" stripeKey="pk_test_CArw3ofMsipz60vicTMloBqQ" token={onToken}>

                                        <Button label={l.create_account}
                                            type='primary'
                                            size='md'
                                            fullWidth="fullWidth"
                                        />
                                    </StripeCheckout>
                                    : <Button onClick={handleSignupBtn}
                                        label={l.create_account}
                                        type='primary'
                                        size='md'
                                        fullWidth="fullWidth"
                                    />}

                                {/* stripeKey="pk_test_CArw3ofMsipz60vicTMloBqQ"
                        currency="INR"
                        name="Basic"
                        description="Basic plan with limited futures."
                        panelLabel="Create"
                    /> */}

                                {/* </div>
                                </form>  */}
                                {/* <div className="crdRowBlock mrgTop24">
                                    <small className="pTxt blackInactiveTxt txtCenter">{l.terms_msg}
                                        <Link to="/terms-conditions" target="_blank" className="linkTxt linkTxtSm"> {l.terms_cond}</Link> {l.and}
                                        <Link to="/privacy-policy" target="_blank" className="linkTxt linkTxtSm"> {l.privacy_policy}</Link> {l.agreeTxt}.</small>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="footerRow">
                        <div className="rowSpaceBtwn">
                            <p className="pTxt mrgRight16">{l.alrdy_have_acct}</p>
                            <Link to="/" className="linkTxt linkTxtLg">{l.login}</Link>
                        </div>
                        <div className="crdRowBlock">
                            <small className="smallTxt blackInactiveTxt txtCenter">{l.terms_msg}
                                <Link to="/terms-conditions" target="_blank" className="linkTxt linkTxtSm"> {l.terms_cond}</Link> {l.and}
                                <Link to="/privacy-policy" target="_blank" className="linkTxt linkTxtSm"> {l.privacy_policy}</Link> {l.agreeTxt}.</small>
                        </div>
                        <small className="smallTxt txtCenter blackInactiveTxt">
                                {l.contact_for}{" "}
                                <a href="https://help.peoplelinkvc.com/portal/en/newticket" target="_blank" className="linkTxt linkTxtSm" rel="noopener noreferrer">
                                    {l.support}
                                </a>
                            </small>
                    </div>

                </div>
            </div>
            {/* {confirmMsg &&
                <ConfirmMsgPopup />
            } */}
        </div>

    </Fragment>
}

export default AdminSignupPage;